
import { AnyAction } from "redux"
import { ADMIN_EMPLOYES_DATA_FAIL, ADMIN_EMPLOYES_DATA_REQ, ADMIN_EMPLOYES_DATA_SUCC, ADMIN_EMPLOYES_DATA_SUCC_SEARCH } from "redux/actions/admin/employes/type"
import { ADMIN_LOCATIONSQR_DATA_FAIL, ADMIN_LOCATIONSQR_DATA_REQ, ADMIN_LOCATIONSQR_DATA_SEARCH, ADMIN_LOCATIONSQR_DATA_SUCC, ADMIN_LOCATIONSQR_DATA_SUCC_SEARCH } from "redux/actions/admin/QrCodes/type"
  

interface State {
    loading?: boolean
    data?: any,
    error?: string,
    search?:any
    


}

const defaultState: State = {
    loading: false,
    data: [],
    search:[]
    


}

 

 

// export const ADMIN_LOCATIONSQR_DATA_FAIL="ADMIN_LOCATIONSQR_DATA_FAIL"
// export const ADMIN_LOCATIONSQR_DATA_REQ="ADMIN_LOCATIONSQR_DATA_REQ"
// export const ADMIN_LOCATIONSQR_DATA_SUCC="ADMIN_LOCATIONSQR_DATA_SUCC"


 


export const getAdminLocationsQrReducer = (state: State = defaultState, action: AnyAction) => {
    switch (action.type) {
        case ADMIN_LOCATIONSQR_DATA_REQ:

            return {
                loading: true,
                data: state.data,
                search:state.search,
                 
            }
        case ADMIN_LOCATIONSQR_DATA_SUCC:

            return {
                loading: false,
                data: action.payload,
                search: action.payload,
            }

            case ADMIN_LOCATIONSQR_DATA_SUCC_SEARCH:
                return {
                      
                    data:state.data,
                    search:action.payload

                }
        case ADMIN_LOCATIONSQR_DATA_FAIL:
            return {
                loading: false,
                error: action.payload,
                data:state.data,
                search:state.search,
            }
            

           
        default:
            return state;
    }
}